export const unauthenticatedURL = [
  '/login',
  '/signup',
  '/verify',
  '/forgot-password',
  '/reset-password',
  '/resend-verification-link'
]
